<template>
  <div>
    <div class="chat-room" id="chat-room" v-bind:style="{ height: chatHeight }">
      <div v-for="o in chatMessages" v-bind:key="`${o.t}`" class="mb-2"><div class="float-right"><small class="text-insignificant">{{ toTime(new Date(o.t.seconds * 1000)) }}</small></div><strong><Username :uid="get_uid(o.u)" :img="get_img(o.u)" :username="get_username(o)"></Username></strong> {{ o.m }}</div>
    </div>
    <input v-if="canSendMessage()" type="text" class="form-control mt-2" @keyup.enter.prevent="sendMessage" v-model="chatMessage" :placeholder="sendMessagePlaceholder">
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import jQuery from 'jquery';
import { Howl } from 'howler';
import Username from '@/components/Username.vue';

const $ = jQuery;

export default {
  name: 'ChatAndNotes',
  props: ['roomId', 'canSendMessage', 'sendMessagePlaceholder', 'chatHeight'],
  components: {
    Username,
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'getCurrentUser', 'getUserData', 'getDefaultUsername']),
  },
  created() {
    const db = window.firebase.firestore();

    this.chatRef = db.collection('chats').doc(this.roomId);

    this.chatRef.onSnapshot((doc) => {
      if (typeof doc.data() !== 'undefined') {
        this.chatCreated = true;
        this.chatMessages = doc.data().messages;
      }
    });
  },
  watch: {
    chatMessages: {
      handler() {
        const $elem = $('#chat-room');
        if ($elem.is(':visible')) {
          $elem.animate({ scrollTop: $elem[0].scrollHeight + 10000 }, 400);
        }

        if (this.chatMessages.length > 0) {
          const lastMessage = this.chatMessages[this.chatMessages.length - 1];
          if (lastMessage.u !== this.getCurrentUser.uid) {
            this.chatSound.play();
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    get_uid(uid) {
      if (uid.indexOf('discord_') === 0) {
        const splitted = uid.split('_');
        return `discord_${splitted[1]}`;
      }
      return uid;
    },
    get_img(uid) {
      if (uid.indexOf('discord_') === 0) {
        const splitted = uid.split('_');
        if (splitted[2].indexOf('?size=') > -1) {
          return `${splitted[2].split('size=')[0]}size=64`;
        }
        return splitted[2];
      }
      return null;
    },
    get_username(msg) {
      const uid = msg.u;
      if (uid.indexOf('discord_') === 0) {
        return `<a href="https://discord.gg/XmxVHV7" target="_blank">${msg.s}</a>`;
      }
      return msg.s;
    },
    toTime(d) {
      const hh = `${d.getHours()}`.padStart(2, 0);
      const mm = `${d.getMinutes()}`.padStart(2, 0);
      return `${hh}:${mm}`;
    },
    sendMessage() {
      if (!this.canSendMessage()) {
        return false;
      }

      if (!this.chatCreated) {
        this.chatRef.set({
          messages: [],
        });
      }

      if (this.chatMessage.trim() !== '') {
        const s = (this.getCurrentUser && this.getCurrentUser.isAnonymous) ? this.getDefaultUsername : this.getUserData.username;
        const message = {
          u: this.getCurrentUser.uid,
          s,
          m: this.chatMessage,
          t: window.firebase.firestore.Timestamp.fromDate(new Date()),
        };

        this.chatMessages.push(message);
        this.chatRef.update({
          messages: window.firebase.firestore.FieldValue.arrayUnion(message),
        });
        this.chatMessage = '';

        return true;
      }

      return false;
    },
    setCurrentTab(tab) {
      this.currentTab = tab;
      Vue.localStorage.set('chatOrNoteTab', tab);
      setTimeout(() => {
        const $elem = $('#chat-room');
        if ($elem.is(':visible')) {
          $elem.animate({ scrollTop: $elem[0].scrollHeight + 10000 }, 400);
        }
      }, 0);
    },
  },
  data() {
    return {
      chatCreated: false,
      chatRef: null,
      chatMessages: [],
      chatMessage: '',
      chatSound: new Howl({ src: ['/chat.m4r', '/chat.mp3', '/chat.ogg'] }),
    };
  },
};
</script>

<style lang="scss" scoped>
.chat-room {
  padding: 0;
  width: 100%;
  height: 250px;
  overflow: scroll;
}
</style>
